import React, { useEffect, useState } from "react";
import { Todo } from "../models/Todo";
import Input from "./Input";
import TodoList from "./TodoList";
import { v4 as uuidv4 } from "uuid";

function TodoApp() {
  const [todos, setTodos] = useState<Todo[]>([]);
  const [shouldSort, setShouldSort] = useState(false);

  async function submitTodo(
    input: string,
    e: React.FormEvent<HTMLFormElement>
  ) {
    e.preventDefault();
    if (!input) return;
    setTodos([...todos, new Todo(uuidv4(), input, false, Date.now())]);
  }

  const removeTodo = (todo: Todo) => {
    const filteredTodos = todos.filter((t) => t.id !== todo.id);
    setTodos(filteredTodos);
  };

  const updateTodo = (todo: Todo) => {
    let temp = [...todos];

    for (let i = 0; i < temp.length; i++) {
      if (temp[i].id === todo.id) {
        temp[i] = todo;
      }
    }
    setShouldSort(!shouldSort);
    setTodos(temp);
  };

  const unDoneTasks = () => {
    let unDoneTodos = todos.filter((todo) => todo.isDone === false);
    // setunDoneTodos(unDoneTodos.length);
    return (
      <div className={"bg-green-100 rounded-md p-2 text-sm mb-8 border"}>
        <p>You have {unDoneTodos.length.toString()} undone tasks</p>
      </div>
    );
  };

  useEffect(() => {
    let tasks = todos.sort((x, y) =>
      x.isDone === y.isDone ? 0 : x.isDone ? 1 : -1
    );
    setTodos([...tasks]);
  }, [shouldSort]);

  return (
    <div className="">
      <Input submitTodo={submitTodo} />

      {unDoneTasks()}

      <TodoList
        todos={todos}
        updateTodo={updateTodo}
        removeTodo={removeTodo}
        setTodos={setTodos}
      />
    </div>
  );
}

export default TodoApp;
